import StateBlock from './ui/StateBlock';

interface ErrorStateProps {
  /** Main line; defaults to "לא הצלחנו לטעון את המידע". */
  message?: string;
  /** Retry handler (usually a react-query `refetch`). Hidden when omitted. */
  onRetry?: () => void;
  /** The rejection: 403 / 404 get their own state, the server text goes under "פרטים טכניים". */
  error?: unknown;
  className?: string;
}

/** Thin wrapper over `ui/StateBlock kind="error"` (T-38); kept for existing call sites. */
export default function ErrorState({ message, onRetry, error, className = '' }: ErrorStateProps) {
  return <StateBlock kind="error" size="panel" title={message} onRetry={onRetry} error={error} className={className} />;
}
